import jQuery from 'jquery';
import objectFitImages from 'object-fit-images';

const Drupal = window.Drupal;

(function(jQuery, Drupal) {
  'use strict';

  objectFitImages();

})(jQuery, Drupal);
